import { all, fork } from 'redux-saga/effects'
import uploadImageSaga from './uploadImageSaga'
import deleteImageSaga from './deleteImageSaga'
import checkImageNameSaga from './checkImageName'
import resetImageInputSage from './resetImageInputsSaga'

export default function* gallerySaga() {
  yield all([fork(uploadImageSaga), fork(deleteImageSaga), fork(checkImageNameSaga), fork(resetImageInputSage)])
}
